export enum loanStatus {
    "applied" = "applied",
    "draft" = "draft",
    "loggedin" = "loggedIn",
    "callback" = "callBack",
    "notconnected" = "notConnected",
    "notresponsive" = "notResponsive",
    "duplicate" = "duplicate",
    "futureprospect" = "futureProspect",
    "needdocuments" = "needDocuments",
    "approved" = "approved",
    "disbursed" = "disbursed",
    "closed" = "closed",
    "rejected" = "rejected",
    "notinterested" = "notInterested",
    "notdoable" = "notDoable",
    "sanctionletter" = "sanctionLetter",
    "invalidnumber" = "invalidNumber",
    "pfpending" = "pfPending",
    "pfpaid" = "pfPaid"
}
export enum leadStatus {
    "New" = "New",
    "serviceStarted" = "serviceStarted",
    "duplicate" = "duplicate",
    "notResponsive" = "notResponsive",
    "notConnected" = "notConnected",
    "needsAction" = "needsAction",
    "notInterested" = "notInterested",
    "futureProspect" = "futureProspect",
    "serviceDelivered" = "serviceDelivered",
    "commissionReceived" = "commissionReceived",
    "commissionpending" = "commissionpending",
    "commissionNotApplicable" = "commissionNotApplicable",
    "bookingCancelled" = "bookingCancelled",
    "refunded" = "refunded",
    "serviceCancelled" = "serviceCancelled"
}

export enum LoanType {
    Collateral = "Secured Loan(with Property)",
    NonCollateral = "Unsecured Loan(without Property)",
    International = "International Loan(Non Collateral-Cosigner)"
  }